import { render, staticRenderFns } from "./AboutExaminerModal.vue?vue&type=template&id=f9de0520&"
import script from "./AboutExaminerModal.vue?vue&type=script&lang=ts&"
export * from "./AboutExaminerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports